import { render, staticRenderFns } from "./recycleGameBalance.vue?vue&type=template&id=20a0a330&"
import script from "./recycleGameBalance.vue?vue&type=script&lang=js&"
export * from "./recycleGameBalance.vue?vue&type=script&lang=js&"
import style0 from "./recycleGameBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports